import { useCallback, useState, useMemo, useEffect, useRef } from "react"
import { Card, Button } from "antd"
import { mapStatus, getStatusColor } from "../../../utils/mappers"
import { useUser } from "../../../contexts/UserContext"
import { useCards } from "../../../contexts/CardsContext"
import { fetchSensorValues, fetchSensorMeta } from "../../../api/Cards"
import { POLL_INTERVAL } from "../../../api/Cards/constants"
import "./SmartCard.css"
import { Link, useNavigate, useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next"

const SmartCard = ({ card, isOffline, onManageCard }) => {
    const { getToken, isAdmin, isReadOnly } = useUser()
    const { setSelectedCard } = useCards()
    const [cardData, setCardData] = useState()
    const intervalRef = useRef(null)
    const navigate = useNavigate()
    const token = useMemo(() => getToken(), [getToken])
    const location = useLocation()
    const { t } = useTranslation()

    useEffect(() => setSelectedCard)

    const updateSensorData = (data) => {
        if (!data) return
        setCardData(data)
    }

    useEffect(() => {
        if (!token || card.status === 3)
            return

        async function fetchData() {
            const data = await fetchSensorMeta(token, card.id, card.cardIndex)
            if (typeof data == "number") {

                return
            }
            updateSensorData(data)
        }

        fetchData()
    }, [card.cardIndex, card.id, setCardData, card.status, token])
    
    const fetchSensorValuesCB = useCallback(async () => {
        const values = await fetchSensorValues(token, card.id, card.cardIndex)
        if (typeof values == "number") {

            return
        }

        const newCardMetaData = cardData.map((cd, i) => ({
            ...cd,
            Value: values[i]
        }))
        setCardData(newCardMetaData)
    }, [token, card.id, card.cardIndex, cardData])

    useEffect(() => {
        if (!cardData) return

        intervalRef.current = setInterval(fetchSensorValuesCB, POLL_INTERVAL)

        return () => {
            if (intervalRef.current) clearInterval(intervalRef.current)
        }
    }, [card.id, cardData, fetchSensorValuesCB])

    return (
        <Card onClick={() => { if (!isOffline) navigate(`/dashboard/card/${card.id.replaceAll("/", "!")}`, { state: { card } })} } className={`card ${isOffline ? "offline" : ""}`} variant="borderless">
            <div style={{ height: "40px", width: "100%", textAlign:"center", fontSize:"17px" }}>
                <p>{card.cardName ? card.cardName : card.modelName }</p>
            </div>

            <div
                className="status-indicator"
                style={{
                    color: getStatusColor(mapStatus(card.status))
                }}
            ></div>
                <div className={`card-status ${mapStatus(card.status)}`}>
                <strong>{t('page.cardmanage.status')}:</strong>
                    <span>{mapStatus(card.status).toUpperCase()}</span>
            </div>

            {cardData ? (
                cardData.length > 0 &&
                cardData.map(({ SensorName, SensorUnit, Value }) => (
                    <div className="card-data" key={`${card.cardIndex}_${SensorName}`}>
                        <p>{SensorName}</p>
                        <p>
                            <span>{(Value / 10).toFixed(1)}</span>
                            <span>{SensorUnit}</span>
                        </p>
                    </div>
                ))
            ) : (
                    <div>{t('page.cardmanage.offline')}</div>
                )}
            {isAdmin && !isReadOnly && (<Button onClick={e => { e.stopPropagation(); onManageCard(card.id); }} style={{ position: "absolute", bottom: "10px", left: "35%" }} >{t('page.cardmanage.button')}</Button>)}
        </Card>
    )
}

export default SmartCard
